export default "__VITE_ASSET__2d5aab3d__"